import { makeStyles } from "@material-ui/core"

import { colors } from "@/styles/colors"
import ColorUtil from "@/utils/ColorUtil"

const useStyles = makeStyles(theme => ({
	container: {
		padding: theme.spacing(1, 3),
		...ColorUtil.getBackgroundAndContrastColor(colors.gray[50]),
		minHeight: 48
	},
	statusMessage: {
		fontSize: 14,
		fontWeight: 400
	},
	pauseDateChip: {
		fontSize: 12,
		...ColorUtil.getBackgroundAndContrastColor(colors.green[600])
	},
	pauseDateChip2: {
		fontSize: 12,
		...ColorUtil.getBackgroundAndContrastColor(colors.green[600])
	},
	alertDateChip: {
		fontSize: 12,
		...ColorUtil.getBackgroundAndContrastColor(colors.yellow[500])
	},
	statusIcon: {
		width: 12,
		height: 12,
		borderRadius: "100%",
		borderWidth: "2px",
		borderStyle: "solid",
		...ColorUtil.getBackgroundAndContrastColor(colors.gray[600]),
		borderColor: colors.gray[400]
	},
	statusIconActive: {
		...ColorUtil.getBackgroundAndContrastColor(colors.green[600]),
		borderColor: colors.green[400]
	},
	statusIconAlert: {
		...ColorUtil.getBackgroundAndContrastColor(colors.yellow[500]),
		borderColor: colors.yellow[300]
	}
}))

export default useStyles
